import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { getInlineLoader } from "../Helpers";

import wp1 from "../assets/Waterproofing/banner1.jpeg";
import wp2 from "../assets/Waterproofing/banner2.jpg";
import wp3 from "../assets/Waterproofing/banner3.jpg";
import tz1 from "../assets/Terrazzo/banner1.jpeg";
import tz2 from "../assets/Terrazzo/banner2.jpg";
import tz3 from "../assets/Terrazzo/banner3.jpg";
import lgs1 from "../assets/LGS/banner1.jpeg";
import lgs2 from "../assets/LGS/banner2.jpg";
import lgs3 from "../assets/LGS/banner3.jpg";
import wp from "../assets/Waterproofing/banner4.jpg";
import tz from "../assets/Terrazzo/banner5.jpeg";
import lgs from "../assets/LGS/banner4.jpeg";


export default function CoreServices() {
  const [ready, setReady] = useState(false);
  const [activeImage, setActiveImage] = useState(null);

  const galleryImages = [
    { src: wp1, title: "Roof membrane protection", category: "Waterproofing" },
    { src: wp2, title: "Wet area sealing system", category: "Waterproofing" },
    { src: wp3, title: "Foundation water barrier", category: "Waterproofing" },
    { src: tz1, title: "Terrazzo lobby finish", category: "Terrazzo" },
    { src: tz2, title: "Public corridor surfaces", category: "Terrazzo" },
    { src: tz3, title: "Custom aggregate layout", category: "Terrazzo" },
    { src: lgs1, title: "Light gauge framing", category: "LGS" },
    { src: lgs2, title: "Modular steel panels", category: "LGS" },
    { src: lgs3, title: "Rapid install systems", category: "LGS" },
    { src: wp, title: "Wet area sealing system", category: "Waterproofing" },
    { src: tz, title: "Clean Finish", category: "Terrazzo" },
    { src: lgs, title: "Rapid install systems", category: "LGS" },
  ];

  useEffect(() => {
    setReady(true);
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    if (!activeImage) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [activeImage]);

  if (!ready) {
    return (
      <div className="container mSupportLoading d-flex justify-content-center align-items-center min-vh-50">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <>
      <section className="MainBodySection gallery-section">
        <div className="container mt-5">
          <header className="gallery-header" data-aos="fade-up">
            <p className="text-primary fs-3 font-bold">PROJECT GALLERY</p>
            <h2 className="gallery-title">Clean Finishes, Durable Systems</h2>
            <p className="gallery-subtitle">
              A curated selection of waterproofing, terrazzo flooring, and light gauge steel projects.
            </p>
          </header>

          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <button
                key={`${image.title}-${index}`}
                type="button"
                className="gallery-card"
                onClick={() => setActiveImage(image)}
                data-aos="fade-up"
                data-aos-delay={80 + index * 60}
                aria-label={`Open ${image.title}`}
              >
                <img
                  className="gallery-image"
                  src={image.src}
                  alt={image.title}
                  loading="lazy"
                />
                <div className="gallery-overlay">
                  <div className="gallery-overlay-content">
                    <span className="gallery-tag">{image.category}</span>
                    <span className="gallery-preview">Preview</span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {activeImage ? (
        <div className="gallery-lightbox" onClick={() => setActiveImage(null)}>
          <div className="gallery-lightbox-inner" onClick={(event) => event.stopPropagation()}>
            <img
              className="gallery-lightbox-image"
              src={activeImage.src}
              alt={activeImage.title}
            />
            <div className="gallery-lightbox-footer">
              <div>
                <p className="gallery-lightbox-title">{activeImage.title}</p>
                <p className="gallery-lightbox-tag">{activeImage.category}</p>
              </div>
              <button
                type="button"
                className="gallery-lightbox-close"
                onClick={() => setActiveImage(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <style>{`
        .gallery-section {
          padding: 80px 0 96px;
          background: radial-gradient(circle at top right, rgba(15, 118, 110, 0.1), transparent 40%),
            linear-gradient(180deg, #f6f9fc 0%, #ffffff 85%);
          font-family: "Inter", "Segoe UI", sans-serif;
        }

        .gallery-header {
          max-width: 760px;
          margin: 0 auto 36px;
          text-align: center;
        }

        .gallery-eyebrow {
          margin: 0;
          text-transform: uppercase;
          letter-spacing: 0.24em;
          font-size: 12px;
          color: #0f766e;
          font-weight: 600;
        }

        .gallery-title {
          margin: 10px 0 12px;
          font-size: clamp(2rem, 3.2vw, 2.6rem);
          color: #0f172a;
        }

        .gallery-subtitle {
          margin: 0 auto;
          max-width: 620px;
          color: #475569;
          font-size: 15px;
          line-height: 1.7;
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 18px;
        }

        .gallery-card {
          position: relative;
          border-radius: 18px;
          overflow: hidden;
          border: 1px solid rgba(148, 163, 184, 0.2);
          box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
          padding: 0;
          background: #fff;
          cursor: pointer;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .gallery-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 40px rgba(15, 23, 42, 0.16);
        }

        .gallery-image {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
          transition: transform 0.4s ease;
        }

        .gallery-card:hover .gallery-image {
          transform: scale(1.04);
        }

        .gallery-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: flex-end;
          padding: 16px;
          background: linear-gradient(0deg, rgba(15, 23, 42, 0.65) 0%, rgba(15, 23, 42, 0) 65%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .gallery-card:hover .gallery-overlay {
          opacity: 1;
        }

        .gallery-overlay-content {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }

        .gallery-tag {
          font-size: 12px;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #e2e8f0;
        }

        .gallery-preview {
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: #ffffff;
          padding: 6px 12px;
          border-radius: 999px;
          font-size: 12px;
          letter-spacing: 0.04em;
          text-transform: uppercase;
        }

        .gallery-lightbox {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.75);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 24px;
        }

        .gallery-lightbox-inner {
          background: #ffffff;
          border-radius: 18px;
          overflow: hidden;
          width: min(960px, 100%);
          box-shadow: 0 24px 60px rgba(15, 23, 42, 0.3);
        }

        .gallery-lightbox-image {
          width: 100%;
          max-height: 70vh;
          object-fit: cover;
          display: block;
        }

        .gallery-lightbox-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 16px 18px;
        }

        .gallery-lightbox-title {
          margin: 0;
          font-size: 16px;
          color: #0f172a;
        }

        .gallery-lightbox-tag {
          margin: 4px 0 0;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #0f766e;
        }

        .gallery-lightbox-close {
          border: none;
          background: #0f766e;
          color: #ffffff;
          padding: 8px 16px;
          border-radius: 999px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
        }

        @media (max-width: 767px) {
          .gallery-section {
            padding: 64px 0 80px;
          }

          .gallery-image {
            height: 200px;
          }

          .gallery-lightbox-footer {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </>
  );
}
